// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let DocumentV3Api = class DocumentV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Creates a new Document.
     * @param DocumentCreateModel Document Create Model object
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentCreateByProgramId(DocumentCreateModel, x_program_id) {
        const _url_ = '/document/v3/Document';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'DocumentCreateModel' is not null or undefined
        if (DocumentCreateModel === null || DocumentCreateModel === undefined) {
            throw new Error('Required parameter DocumentCreateModel was null or undefined when calling documentCreateByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(DocumentCreateModel, "DocumentCreateModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LongDocumentDocumentCreateModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get a Document by Document identifier.
     * @param documentId Document identifier.
     * @param x_program_id The program id from the list of allowed program ids
     */
    async documentGetByProgramId(documentId, x_program_id) {
        const _url_ = '/document/v3/Document/{documentId}'
            .replace('{' + 'documentId' + '}', encodeURIComponent(String(documentId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'documentId' is not null or undefined
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling documentGetByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Creates a new Document.
     * @param DocumentPdfDocumentModel InsertDocumentRequestModel object
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pdfDocumentCreateByProgramId(DocumentPdfDocumentModel, x_program_id) {
        const _url_ = '/document/v3/PdfDocument';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'DocumentPdfDocumentModel' is not null or undefined
        if (DocumentPdfDocumentModel === null || DocumentPdfDocumentModel === undefined) {
            throw new Error('Required parameter DocumentPdfDocumentModel was null or undefined when calling pdfDocumentCreateByProgramId.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(DocumentPdfDocumentModel, "DocumentPdfDocumentModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentLongResponse");
        }
        return response;
    }
};
DocumentV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], DocumentV3Api);
export { DocumentV3Api };
//# sourceMappingURL=documentV3Api.js.map